import { Link } from '@tanstack/react-router';
import type { FCC } from 'common/typeUtils';

type LinkProps = Omit<React.ComponentProps<typeof Link>, 'to'>;
type Props = {
  to: string;
} & LinkProps;

export const SmartLink: FCC<Props> = ({ to, children, ...rest }) => {
  const isInternal = to.indexOf('://') === -1;
  return isInternal ? (
    <Link to={to} {...rest}>
      {children}
    </Link>
  ) : (
    <a href={to} target="_blank" className="link-text" {...rest}>
      {children}
    </a>
  );
};
